import { render, staticRenderFns } from "./Channels.vue?vue&type=template&id=332f1c81&"
import script from "./Channels.vue?vue&type=script&lang=ts&"
export * from "./Channels.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports